'use client'

import CompanyInfo from '@/containers/CompanyInfo'
import { useHeaderFooter } from '@/lib/providers/FooterProvider'
import { useAuthStore } from '@/lib/stores/authStore'
import React from 'react'

interface FooterProps {
  children?: React.ReactNode
}

const Footer: React.FC<FooterProps> = ({ children }) => {
  const { hideFooter } = useHeaderFooter()
  const { user } = useAuthStore()

  if (hideFooter || !user) {
    return null
  }

  return (
    <footer className="flex w-full flex-col items-start gap-2 border-t border-[#E5E5E5] bg-white px-4 py-5">
      <CompanyInfo />
      {children}
    </footer>
  )
}

export default Footer
